





// import React from 'react';

// const WhyChooseTevily = () => {
//   return (
//     <section className="elementor-section elementor-top-section elementor-element elementor-element-2e35c06 elementor-section-full_width elementor-section-height-default row-top" data-id="2e35c06">
//       <div className="elementor-container elementor-column-gap-default">
//         {/* Left Column - Spacer */}
//         <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-335b95e column-line-right" data-id="335b95e">
//           <div className="elementor-widget-wrap elementor-element-populated why-choose__left-bg">
//             <div className="elementor-element elementor-element-b0cdee3 elementor-widget elementor-widget-spacer" data-id="b0cdee3">
//               <div className="elementor-widget-container">
//                 <div className="elementor-spacer">
//                   <div className="elementor-spacer-inner"></div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Content */}
//         <div className="elementor-column elementor-col-50 abhish elementor-top-column elementor-element elementor-element-8e02af2" data-id="8e02af2">
//           <div className="elementor-widget-wrap elementor-element-populated">

//             {/* Heading Block */}
//             <div className="elementor-element elementor-element-733cf51 elementor-widget elementor-widget-gva-heading-block fadeInUp">
//               <div className="elementor-widget-container">
//                 <div className="gva-element-gva-heading-block gva-element">
//                   <div className="align-left style-1 widget gsc-heading box-align-left auto-responsive">
//                     <div className="content-inner">
//                       <div className="sub-title"><span>Our benefit lists</span></div>
//                       <h2 className="title text-white"><span>Why Choose Tevily</span></h2>
//                       <div className="title-desc">
//                         There are many variations of passages of Lorem Ipsum is simply free text available in the market for you, but the majority have suffered alteration in some form.
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Icon Box 1 */}
//             <div className="elementor-element elementor-element-be8db51 elementor-widget elementor-widget-icon-box fadeInUp" data-id="be8db51">
//               <div className="elementor-widget-container">
//                 <div className="elementor-icon-box-wrapper">
//               <div className="elementor-icon-box-icon">
//   <span className="elementor-icon">
//     <i className="flaticon-travel" aria-hidden="true"></i>
//   </span>
// </div>

                  
//                   <div className="elementor-icon-box-content">
//                     <h3 className="elementor-icon-box-title">
//                       <span className='text-white'>Professional and Certified</span>
//                     </h3>
//                     <p className="elementor-icon-box-description">
//                       Lorem ipsum is simply free text dolor sit but the majority have suffered amet, consectetur notted.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Icon Box 2 */}
//             <div className="elementor-element elementor-element-b61ea3b elementor-widget elementor-widget-icon-box fadeInUp" data-id="b61ea3b">
//               <div className="elementor-widget-container">
//                 <div className="elementor-icon-box-wrapper">
//                   <div className="elementor-icon-box-icon">
//                     <span className="elementor-icon">
//                       <i className="flaticon-reisekarte" aria-hidden="true"></i>
//                     </span>
//                   </div>
//                   <div className="elementor-icon-box-content">
//                     <h3 className="elementor-icon-box-title">
//                       <span className='text-white'>Get Instant Tour Bookings</span>
//                     </h3>
//                     <p className="elementor-icon-box-description">
//                       Lorem ipsum is simply free text dolor sit but the majority have suffered amet, consectetur notted.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseTevily;









import React from 'react';

const WhyChooseMeghanaCabs = () => {
  return (
    <section className="why-meghana-section">
      <div className="why-meghana-container">

        {/* LEFT Column with background and logo */}
        <div className="why-meghana-left">
          <div className="why-meghana-bg">
            <div className="why-meghana-loo">
              <img src="/images/logo.png" alt="Meghana Logo" />
            </div>
          </div>
        </div>

        {/* RIGHT Column with text */}
        <div className="why-meghana-right">
          <div className="why-meghana-content">
            <div className="why-meghana-heading">
              <div className="why-meghana-subtitle">Best Cab Services</div>
              <h2 className="why-meghana-title">Why Choose Meghana Cabs?</h2>
            </div>

            <ul className="why-meghana-list">
              <li>
                <span className="why-meghana-check">✔</span>
                <strong>Affordability:</strong> Quality service does not have to come at a premium. We offer competitive rates, ensuring that our services are accessible to everyone.
              </li>
              <li>
                <span className="why-meghana-check">✔</span>
                <strong>Reliability:</strong> When you choose Meghana Cabs, you are choosing a company that is synonymous with punctuality and dependability.
              </li>
              <li>
                <span className="why-meghana-check">✔</span>
                <strong>Experienced Drivers:</strong> Our team is experienced, professional & skilled drivers.
              </li>
            </ul>

          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseMeghanaCabs;
